import { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'

import { useUmrahError } from 'entities/umrah/hooks/useUmrahError.tsx'
import { UmrahTourDetail } from 'entities/umrah/ui/umrah-detail'

import { UmrahBuyTourApi, UmrahMyOrderDetail } from 'shared/api/umrah/buy-tour'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

const UmrahMyOrderDetailPage = () => {
  const { orderId } = useParams() as { orderId: string }
  const { showError } = useUmrahError()

  const [order, setOrder] = useState<UmrahMyOrderDetail | null>(null)
  const [loading, setLoading] = useState(false)

  const getOrderDetail = async () => {
    setLoading(true)
    try {
      const { data: orderData } =
        await UmrahBuyTourApi.getMyOrderDetail(orderId)
      setOrder(orderData?.data)
    } catch {
      showError()
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void getOrderDetail()
  }, [])

  return loading ? (
    <div className={s.loader}>
      <Loader />
    </div>
  ) : (
    order && (
      <UmrahTourDetail
        tour={order.tour}
        pilgrimsCount={order.pilgrim_count}
      />
    )
  )
}

export default UmrahMyOrderDetailPage
